import path from 'path'
// import HardSourceWebpackPlugin from 'hard-source-webpack-plugin'
import CopyWebpackPlugin from 'copy-webpack-plugin'
import WebpackOnBuildPlugin from 'on-build-webpack'
import { ensureInstallation } from './npm-dyn-dependencies'
// import { copyFiles } from './utils'
// import httpServer from './http-server'
import { errorMessage } from './terminal-utils'
// import { spawn } from 'child-process-promise'
import { fileExists, thereIsAnyFileMatching } from './utils'

import _ESLINT from './technologies/eslint'
import _JS from './technologies/js'
import _PERF from './technologies/perf'
import _COFFEE from './technologies/coffee-script'
import _TYPE_SCRIPT from './technologies/type-script'
// import _MARKUPS from './technologies/markups'
// import _MARKUDOWNS from './technologies/markdown'
import _JSON from './technologies/json'

const STARTED_SERVER = {}

export default async function configureServer (opts, state, appRef) {
    const {
        COMMON_CONFIG,
        SRC_PATH,
        OUTPUT_PATH,
        IS_DEV,
        PROJECT_PATH,
        FURTHER_PATH,
        FURTHER_REF
    } = state

    const USED_EXTENSIONS = new Set(await thereIsAnyFileMatching(SRC_PATH, [
      '.js', '.ts', '.tsx', '.coffee', '.json',
      '.htm', '.tpl', '.tpl'
    ]))

    const SERVER_CONFIG = {
      module: {
        rules: []
      }
    }

    async function ensureInstall (what) {
      return await ensureInstallation(what, null,
      {
        verbose: true,
        installing: opts.installing
      })
    }
  
    // we have to install all the dependencyes for projects
    // that use a server side
    await ensureInstall('server')

    // let's make it clear that it's in node environment
    SERVER_CONFIG.target = 'node'

    SERVER_CONFIG.entry = {
        // 'webpack-hot-middleware/client': 'webpack-hot-middleware/client',
        'server/main/index': `${SRC_PATH}/server/main/index.js`,
        // 'vendors/babel-polifills': [
        //   'core-js/es6/function',
        //   'core-js/es6/map',
        //   'core-js/es6/math',
        //   'core-js/es6/number',
        //   'core-js/es6/object',
        //   'core-js/es6/regexp',
        //   'core-js/es6/string',
        //   'core-js/fn/array/includes'
        // ]
    }

    SERVER_CONFIG.module = { rules: [], loaders: [] }
    SERVER_CONFIG.plugins = []

    // let's enable source maps
    if (IS_DEV) {
      SERVER_CONFIG.devtool = 'inline-source-map'
    } else {
        if (opts.production && opts.production.sourceMaps) {
          SERVER_CONFIG.devtool = 'source-map'
        }
    }

    // ESLint
    SERVER_CONFIG.module.rules.push(_ESLINT(state, opts))

    if (USED_EXTENSIONS.has('.json')
      || USED_EXTENSIONS.has('.json5')) {
        await ensureInstall('json')
        SERVER_CONFIG.module.rules.push(_JSON(state))
    }

    // rules for javascript (es6+, linter, generators, etc)
    // SERVER_CONFIG.module.rules.push(_JS(state))

    // Measuring and validating file sizes
    if (IS_DEV) {
      // we install any dependency used for development
      await ensureInstall('developer')
      SERVER_CONFIG.performance = _PERF
    }

    // COFFEE SCRIPT
    if (USED_EXTENSIONS.has('.coffee')) {
      await ensureInstall('coffee')
      SERVER_CONFIG.module.rules.push(_COFFEE(state))
    }

    // TYPE SCRIPT
    if (USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx')) {
      await ensureInstall('typescript')
      SERVER_CONFIG.module.rules.push(_TYPE_SCRIPT(state))
    }

    // rules for javascript (es6+)
    SERVER_CONFIG.module.rules.push({
        // enforce: "pre",
        test: /\.js$/,
        exclude: /node_modules/,
        loader: FURTHER_REF + 'babel-loader',
        options: {
          plugins: [
            FURTHER_REF + "babel-plugin-transform-async-to-generator"
          ],
          presets: [
            [
              FURTHER_REF + 'babel-preset-es2015',
              { modules: false, loose: true }
            ]
          ]
        }
    })



    // if there is any /server/public directory, we will copy it to
    // the dist directory
    if (!await fileExists(`${OUTPUT_PATH}/server/public/`)
      && await fileExists(`${SRC_PATH}/server/public/`)) {
        SERVER_CONFIG.plugins.push(
          new CopyWebpackPlugin([
            {
              from: `${SRC_PATH}/server/public/`,
              to: `${OUTPUT_PATH}/server/public/`,
              ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
            }
          ])
        )
    }

    // if there is any /server/private directory, we will copy it to
    // the dist directory
    if (!await fileExists(`${OUTPUT_PATH}/server/private/`)
      && await fileExists(`${SRC_PATH}/server/private/`)) {
        SERVER_CONFIG.plugins.push(
          new CopyWebpackPlugin([
            {
              from: `${SRC_PATH}/server/private/`,
              to: `${OUTPUT_PATH}/server/private/`,
              ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
            }
          ])
        )
    }

    // To allow developers to start a server by using `node dist/server`
    // we need to add a starter from a further template into their project's dist
    SERVER_CONFIG.plugins.push(
      new CopyWebpackPlugin([
        {
          // copying the SERVER STARTER file
          from: path.join(FURTHER_REF, '../dist/tpls/server/', 'further-http-server.js'),
          to: path.join(OUTPUT_PATH, 'server/index.js'),
          ignore: ['**/**/.DS_Store', '**/**/.gitkeep'],
          transform: (content, path) => {
            // replacing some marks/tokens
            content = content.toString()
            content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null')
            return Buffer.from(content, 'utf8')
          }
        }
      ])
    )



    // SERVER_CONFIG.plugins = [
    //   // new EventsPlugin(),
    //   new CopyWebpackPlugin([
    //     {
    //       from: `${SRC_PATH}/server/public/`,
    //       to: `${OUTPUT_PATH}/server/public/`,
    //       ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
    //     },
    //     {
    //       from: `${SRC_PATH}/server/private/`,
    //       to: `${OUTPUT_PATH}/server/private/`,
    //       ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
    //     }
    //   ]),
    //   // new webpack.HotModuleReplacementPlugin()
    // ]
    
    // caching modules to make next builds faster
    // SERVER_CONFIG.plugins.push(new HardSourceWebpackPlugin({
    //   cacheDirectory: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]'),
    //   recordsPath: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]/records.json')
    // }))

    // resolves
    SERVER_CONFIG.resolve = {
      extensions: [
        ".webpack.js", ".web.js", ".js", ".ts", ".tsx", ".jsx", ".coffee",
        "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg",
        ".html", ".tpl",
        ".css", ".less", ".styl", ".sass"
      ], //, ".mjs", ".coffee", ".vue", ".less", ".styl", ".sass" ],
      alias: {
        react: 'preact-compat',
        'react-dom': 'preact-compat',
        Components: path.resolve(PROJECT_PATH, 'src/client/components/'),
        Comps: path.resolve(PROJECT_PATH, 'src/client/components/'),
        Templates: path.resolve(PROJECT_PATH, 'src/templates/'),
        Services: path.resolve(PROJECT_PATH, 'src/server/services/'),
        Servs: path.resolve(PROJECT_PATH, 'src/server/services/')
      },
      modules: [
        'furtherjs/node_modules',
        'node_modules/furtherjs/node_modules',
        'node_modules'
      ]
    }

    // the output path
    SERVER_CONFIG.output = {
        libraryTarget: 'umd',
        path: OUTPUT_PATH,
        filename: '[name].js',
        chunkFilename: '[name]-[id].js',
        hotUpdateChunkFilename: 'hot/[hash].hot.js',
        hotUpdateMainFilename: 'hot/[hash].hot.json'
    }

    // Measuring and validating file sizes
    // SERVER_CONFIG.performance = {
    //     hints: "warning", // enum
    //     maxAssetSize: 350000, // int (in bytes),
    //     maxEntrypointSize: 400000, // int (in bytes)
    //     assetFilter: function(assetFilename) {
    //         // Function predicate that provides asset filenames
    //         return assetFilename.endsWith('.js');
    //     }
    // }
    // SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function(stats) {
    //   // unless the user has disabled it, we start an HTTP Server
    //   if (appRef.onBuildDone) {
    //     appRef.onBuildDone('server', null, stats)
    //   }
    // }))

    // SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function (stats) {
    //   return new Promise(async (resolve, reject) => {
    //     await state.appRef.onBuildDone('server', SERVER_CONFIG, stats)

    //     // if server has already started, we kill it
    //     if (STARTED_SERVER.proc && STARTED_SERVER.proc.childProcess) {
    //       STARTED_SERVER.proc.childProcess.kill()
    //     }
        
    //     // and now we start the server
    //     STARTED_SERVER.proc = spawn(
    //       'node',
    //       [path.resolve(PROJECT_PATH, 'dist/server/index.js')],
    //       { capture: [ 'stdout', 'stderr' ]})
    //         .then(function (result) {
    //           // if (opts.debug) {
    //             console.log('[Server log] ', result.stdout.toString())
    //           // }
    //         })
    //         .catch(function (err) {
    //             console.log(errorMessage('Server execution error: ' + err.stderr))
    //         });

    //     resolve(SERVER_CONFIG)
    //   })
    // }))
    SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function(stats) {
      // unless the user has disabled it, we start an HTTP Server
      if (opts.server.http !== false) {
        try {
            if (appRef.onBuildDone) {
              appRef.onBuildDone('server', null, stats)
            }
        } catch (e) {
          if (opts.breakpointOnErrors) {
            debugger
          }
          stats.compilation.errors.push({
            name: 'Server startup error',
            message: `Could not start HTTP Server.\n${e.message || e}`
          })
        }
      }
    }))

    SERVER_CONFIG.name = 'server-config'


    // we have to remove all the invalid/empty plugins that may
    // have been accidently added
    SERVER_CONFIG.plugins = SERVER_CONFIG.plugins.filter(
      plugin => plugin && (Object.keys(plugin).length || plugin.apply)
    )

    return Object.assign({}, COMMON_CONFIG, SERVER_CONFIG)
}



// WEBPACK FOOTER //
// ./src/configure-server.js